import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useHeldAccounts } from '@/hooks/useHeldAccounts';
import { switchAccount } from '@/lib/activeAccount';

/**
 * "Not the account you meant?" for a page that acts as one account and is opened in a new tab
 * (MCP consent, the console handoff). A new tab starts on the browser's first account, which
 * may not be the one meant; this offers the browser's other signed-in accounts, each reloading
 * this page as that account (docs/MultiAccountSessions.md §4), or `to` when this page belongs to
 * the current account. Renders nothing with only one.
 */
export function ContinueAsAnotherAccount({ to }: { to?: string }) {
  const { user } = useAuth();
  const { data: held = [] } = useHeldAccounts(!!user);
  const others = held.filter((account) => account.signedIn && account.id !== user?.id);
  if (!user || others.length === 0) return null;

  return (
    <div className="space-y-2 border-t border-border-subtle pt-4">
      <p className="text-xs text-muted-foreground">Not the account you meant? Continue as</p>
      {others.map((account) => (
        <Button
          key={account.id}
          variant="outline"
          size="sm"
          className="w-full justify-start truncate"
          onClick={() => { switchAccount(account.id, to); }}
        >
          {account.email}
        </Button>
      ))}
    </div>
  );
}
